import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { useMenu } from '../../hooks/useMenu';
import useApplicationOwnerName from '../../hooks/useApplicationOwnerName';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { HeadingSubtitle } from '../../components/Heading';
import { secureAccountIdentityCountryTitle } from '../../util/helpers/onboardingContentHelpers';
import Paragraph from '../../components/Paragraph/Paragraph';
import IdentityCountryForm from '../../components/Forms/IdentityCountryForm';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import themeColors from '../../assets/styles/themeColors';

const SecureAccountIdentity = ({ applicantType }) => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const applicantName = useApplicationOwnerName(applicantType);
  const { BrokerName, DisplayBrokerCode } = useSelector(selectSettings);
  const formId = 'name_form';
  const [eventType, setEventType] = useState(null);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
      formId={formId}
      setEventType={setEventType}
    >
      <Helmet>
        <title>
          {t('titleTagIdentityVerification', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <HeadingSubtitle color={themeColors.colorTextSecondary}>
        {secureAccountIdentityCountryTitle(applicantType, applicantName)}
      </HeadingSubtitle>
      <Paragraph mb={32} color={themeColors.colorTextXLLight}>
        {t('secureIdentity.subtitle', {
          brokerCode: DisplayBrokerCode,
        })}
      </Paragraph>
      <IdentityCountryForm
        applicantType={applicantType}
        nextPath={activeItem?.nextPath}
        skipStepPath={activeItem?.skipPath}
        dependentSkipStepPath={activeItem?.dependentSkipPath}
        formId={formId}
        setEventType={setEventType}
        eventType={eventType}
      />
    </OnBoardingContainer>
  );
};

SecureAccountIdentity.propTypes = {
  applicantType: PropTypes.string,
};

export default SecureAccountIdentity;
